import React from 'react';
import styles from './styles.module.scss';
import StyledLink from 'components/StyledLink';
import { ASSEMBLED_BOM_DETAILED_PATH } from 'constants/routeConstants';

export default function AssemblyNameCellContent({ row = {} }) {
  const { assembledLooseItem, itemName } = row;

  return (
    <div className={styles.assembly__name}>
      <StyledLink
        to={`${ASSEMBLED_BOM_DETAILED_PATH}/${assembledLooseItem.id}`}
        className={styles.assembly__link}>
        {itemName || ''}
      </StyledLink>
    </div>
  );
}
